import React, { useEffect, useState } from "react";
import Select from "react-select";
import { formatCurrency, toast } from "../../utils/helpers";
import { request } from "../../utils/request";

const ProductoCompra = ({item, index, impuestos, almacen, tipoDescuento, removeItem, updateTotal}) => {
    const [cantidad, setCantidad] = useState(1);
    const [costo, setCosto] = useState("");
    const [viejoCosto, setViejoCosto] = useState(0);
    const [precio, setPrecio] = useState(0);
    const [descuento, setDescuento] = useState(0);
    const [disponible, setDisponible] = useState(0);
    const [impuesto, setImpuesto] = useState(0);
    const [impuesto_id, setImpuesto_id] = useState(null);
    const [precios, setPrecios] = useState([]);
    const [formaDeCalculo, setFormaDeCalculo] = useState('total');
    const [total, setTotal] = useState(0);
    const [selected, setSelected] = useState({});

    const [productos, setProductos] = useState([]);

    const getProductos = async () => {
		const table = await request('productos');

		if (table.data) {
            setProductos(table.data);
		}
	};

    const onChangeInput = (name, value) => {
        if (name === 'descuento') {
            if (tipoDescuento === 'Porcentaje' && parseFloat(value) > 100) {
                toast('El descuento no puede ser major al 100%', 'error');
                return;
            }
            if (tipoDescuento === 'Monto Fijo' && parseFloat(value) > costo) {
                toast('El descuento no puede ser mayor al importe', 'error');
                return;
            }
        }

        switch (name) {
            case 'cantidad':
                setCantidad(value); 
                break;
            case 'costo':
                setCosto(value); 
                break;
            case 'viejoCosto':
                setViejoCosto(value);
                break;
            case 'precio':
                setPrecio(value);
                break;
            case 'descuento':
                setDescuento(value);
                break;
            case 'disponible':
                setDisponible(value);
                break;
            case 'impuesto':
                setImpuesto(value);
                break;
            case 'impuesto_id':
                setImpuesto_id(value);
                break;
            case 'precios':
                setPrecios(value);
                break;
            case 'formaDeCalculo':
                setFormaDeCalculo(value);
                break;
            case 'total':
                setTotal(value);
                break;
            case 'selected':
                setSelected(value);
                break;
            default:
                break;
        }
    };

    const onChangeImpuesto = (value) => {
        const impuesto = impuestos.filter(i => i.id === value)[0];

        setImpuesto(impuesto.porcentaje ?? 0);
        setImpuesto_id(impuesto.id);
    }

    const onChangePreciosVenta = (id, value) => {
        setPrecios(prevState => prevState.map(precio => {
            if (precio.id === id) {
                return {...precio, total: value};
            } 
            return precio;
        }));
    };

    const updatePrecios = () => {
        setPrecios(prevState => prevState.map(precio => {
            const imp = prevState.impuesto > 1 ? prevState.impuesto / 100 : prevState.impuesto;
                if (precio.porciento_beneficio && prevState.viejoCosto < prevState.costo) {
                    precio.total = (parseFloat(prevState.costo) + parseFloat(prevState.costo) * parseFloat(precio.porciento_beneficio / 100)) * ((imp || 0) + 1);
                } else {
                    precio.total = (precio.precio_venta * ((imp || 0) + 1)).toFixed(2);
                }
            return precio;
        }));
    }

    const onChangeItem = (itemId) => {
        const itemCompra = productos.filter((item) => item.id === itemId)[0] || [];

        setFormaDeCalculo('total');
        setCosto(itemCompra.costo || 0);
        setPrecio(itemCompra.precio || 0);
        setDescuento(itemCompra.descuento || 0);
        setViejoCosto(itemCompra.costo ? itemCompra.costo : null);
        setCantidad(1);
        setImpuesto(itemCompra.impuesto?.porcentaje || 0);
        setImpuesto_id(itemCompra.impuesto ? itemCompra.impuesto.id : 0);
        setDisponible(itemCompra.cantidad ? itemCompra.cantidad : 0);
        setPrecios(itemCompra.precios || []);
        setTotal(itemCompra.total);
    };

    const addPrecio = () => {
        setPrecios(prevState => [...prevState, {id: Date.now()}]);
    }
    const removePrecio = (id) => {
        setPrecios(prevState => prevState.filter(p => p.id !== id));
    }    

    const calcularDescuento = (total, descuento, cantidad = 1) => {
        if (tipoDescuento === 'Porcentaje') {
            const porcentajeDesc = descuento ? descuento / 100 : 0;
            return total * porcentajeDesc;
        } else {
            return descuento * cantidad;
        }
    }

    const calcularImpuesto = (total, impuesto) => {
        const p = impuesto < 1 ? impuesto : impuesto / 100;
        return total * p;
    }

    const calcularPorCosto = () => {
        const porcentajeImpuesto = parseFloat(impuesto > 1 ? (impuesto || 0) / 100 : impuesto);
        const desc = calcularDescuento(costo, descuento);
        const precio = (parseFloat(costo) - parseFloat(desc || 0)) * (porcentajeImpuesto + 1);
        const total = precio * cantidad;

        setPrecio(precio);
        setTotal(total);
    }

    const calcularPorPrecio = () => {
        const porcentajeImpuesto = parseFloat(impuesto > 1 ? (impuesto || 0) / 100 : impuesto);
        const total = precio * cantidad;
        const subcosto = precio / (porcentajeImpuesto + 1);
        const desc = calcularDescuento(subcosto, descuento);
        const costo = subcosto + parseFloat(desc || 0);

        setCosto(costo);
        setTotal(total);
    }

    const calcularPorTotal = () => {
        const porcentajeImpuesto = parseFloat(impuesto > 1 ? (impuesto || 0) / 100 : (impuesto || 0));
        const costo = (((total / cantidad)) / (porcentajeImpuesto + 1)) + parseFloat(descuento || 0);

        setCosto(costo);
        setPrecio((total / cantidad));
    }

    useEffect(() => {
        switch (formaDeCalculo) {
            case 'total':
                calcularPorTotal();
                break;
            case 'precio':
                calcularPorPrecio();
                break;
            case 'costo':
            default:
                calcularPorCosto();
                break;
        }
    }, [formaDeCalculo, impuesto, costo, descuento, tipoDescuento, cantidad, precio, total]);

    useEffect(() => {
        let imp = impuestos.filter(i => i.id === impuesto_id)[0];

        if (!imp && item.impuesto) {
            imp = item.impuesto;
        }

        const subTotal = costo * cantidad;
        const totalDesc = calcularDescuento(subTotal, descuento, cantidad);
        const totalImp = calcularImpuesto(subTotal - totalDesc, impuesto);
        const total = subTotal - totalDesc + totalImp;

        if (formaDeCalculo !== 'total') {
            setTotal(total);
        }

        updateTotal(
            item.id,
            total,
            {nombre: imp?.nombre ?? 'Ninguno', totalImpuesto: totalImp},
            totalDesc,
            false
        );

        updatePrecios();
    }, [cantidad, costo, descuento, impuesto, precio, total]);

    useEffect(() => {
        if (item) {
            setFormaDeCalculo('total');
            setCosto(item.costo || 0);
            setTotal(item.total || 0);
            setCantidad(item.cantidad);
            setPrecio(item.total / item.cantidad);
            setDescuento(item.descuento || 0);
            setDisponible(item.item?.cantidad || 1);
            setImpuesto(item.impuesto ? item.impuesto?.porcentaje * 100 : 0);
            setImpuesto_id(item.impuesto?.id || 0);
            setPrecios(item.precios || [{}]);
            setSelected(item.nombre ? {
                label: `${item?.referencia} - ${item?.nombre}`,
                value: item.item_id
            } : null);
        }
    }, []);

    useEffect(() => {
        getProductos();
    }, []);

    const imp = impuestos.filter(i => i.id === impuesto_id)[0] || impuestos[0];

    return <tr>
            <td className='text-center'>
                {index + 1}
            </td>
            <td>
                <input type="hidden" name={`compra[items_compra][p${index}][almacen_id]`} value={almacen || ''} />
                <input type="hidden" name={`compra[items_compra][p${index}][tipo]`} value={item.tipo ?? 'producto'} />
                {item.item_id && (
                    <input type="hidden" name={`compra[items_compra][p${index}][item_id]`} value={item.item_id} />
                    )}
                {item.productoNuevo && (
                    <>
                        <input type="hidden" name={`compra[items_compra][p${index}][referencia]`} value={item.productoNuevo?.referencia} />
                        <input type="hidden" name={`compra[items_compra][p${index}][unidad]`} value={item.productoNuevo?.unidad?.value} />
                        <input type="hidden" name={`compra[items_compra][p${index}][grupo_id]`} value={item.productoNuevo?.categoria?.value} />
                    </>
                )}
                <div className="d-flex">
                    <div style={{flex: 1}}>
                        <Select
                            options={productos && [...productos?.map(i => ({value: i.id, label: i.referencia ? `${i.referencia.padEnd(8, ' ')} - ${i.nombre}` : i.nombre})), selected || {}]}
                            loadingMessage={() => "Cargando items..."}
                            isLoading={!productos.length}
                            value={selected}
                            required
                            onChange={(e) => {
                                setSelected(e);
                                onChangeItem(e?.value);
                            }}
                            name={`compra[items_compra][p${index}][item_id]`}
                            isClearable={true}
                        />
                        {viejoCosto > 0 && (
                            <div style={{with: '100%'}}>
                                <small>
                                    Últ. Precio: {formatCurrency(parseFloat(viejoCosto) + calcularImpuesto(viejoCosto, imp.porcentaje))} | Displonible: {disponible}
                                </small>
                            </div>
                        )}
                    </div>
                </div>
            </td>
            <td>
                <input
                    type='number'
                    name={`compra[items_compra][p${index}][cantidad]`}
                    value={cantidad}
                    min='0.01'
                    onChange={(e) =>
                        onChangeInput("cantidad", e.target.value)
                    }
                    className='form-control text-right'
                    step='any'
                />
            </td>
            <td onDoubleClick={() => setFormaDeCalculo('costo')} title="Doble Click para editar">
                {formaDeCalculo === 'costo' ? (
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text" id="basic-addon1">RD$</span>
                        </div>
                        <input
                            type='number'
                            name={`compra[items_compra][p${index}][costo]`}
                            value={costo || ''}
                            onChange={(e) =>
                                onChangeInput("costo", e.target.value)
                            }
                            className='form-control'
                            step='any'
                        />
                    </div>
                ) : (
                    <div className="m-t-5">
                        <input type="hidden" name={`compra[items_compra][p${index}][costo]`} value={costo} />
                        {formatCurrency(costo)}<i className="fa fa-pen table-edit-field color-primary"></i>
                    </div>
                )}
            </td>
            <td className='text-center'>
                <Select
                    isLoading={!impuestos.length}
                    options={impuestos.map(i => ({
                        label: i.nombre,
                        value: i.id
                    }))}
                    value={imp && {
                        label: imp?.nombre,
                        value: imp?.id,
                    }}
                    onChange={(e) =>
                        onChangeImpuesto(e.value)
                    }
                />
                <input type="hidden" name={`compra[items_compra][p${index}][impuesto_id]`} value={impuesto_id || ''} />
            </td>
            <td className='text-center'>
                <div className="input-group">
                    <div className="input-group">
                        {tipoDescuento === 'Monto Fijo' && (
                            <div className="input-group-append">
                                <span className="input-group-text" id="basic-addon1">RD$</span>
                            </div>
                        )}
                        <input
                            type='number'
                            name={`compra[items_compra][p${index}][descuento]`}
                            value={descuento}
                            min="0"
                            onChange={(e) =>
                                onChangeInput("descuento", e.target.value)
                            }
                            className='form-control'
                            step='any'
                        />
                        {tipoDescuento === 'Porcentaje' && (
                            <div className="input-group-append">
                                <span className="input-group-text" id="basic-addon1">%</span>
                            </div>
                        )}
                    </div>
                </div>
            </td>
            <td onDoubleClick={() => setFormaDeCalculo('precio')} title="Doble Click para editar">
                {formaDeCalculo === 'precio' ? (
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text" id="basic-addon1">RD$</span>
                        </div>
                        <input
                            type='number'
                            name={`compra[items_compra][p${index}][precio]`}
                            value={precio || ''}
                            onChange={(e) =>
                                onChangeInput("precio", e.target.value)
                            }
                            className='form-control'
                            step='any'
                        />
                    </div>
                ) : (
                    <div className="m-t-5">
                        <input type="hidden" name={`compra[items_compra][p${index}][precio]`} value={precio} />
                        {formatCurrency(precio)}<i className="fa fa-pen table-edit-field color-primary"></i>
                    </div>
                )}
            </td>
            <td
                className="text-right"
                onDoubleClick={() => setFormaDeCalculo('total')}
                title="Doble Click para editar"
            >
                {formaDeCalculo === 'total' ? (
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <span
                                className="input-group-text"
                                id="basic-addon1"
                            >
                                RD$
                            </span>
                        </div>
                        <input
                            type="number"
                            name={`compra[items_compra][p${index}][total]`}
                            value={total || 0}
                            onChange={(e) =>
                                onChangeInput("total", e.target.value)
                            }
                            className="form-control text-right"
                            step="any"
                        />
                    </div>
                ) : (
                    <div className="m-t-5">
                        {formatCurrency(total)}<i className="fa fa-pen table-edit-field color-primary"></i>
                    </div>
                )}
                <input
                    type="hidden"
                    name={`compra[items_compra][p${index}][total]`}
                    value={total || 0}
                />
            </td>
            <td className='text-right'>
                <div className="dropdown m-t-5">
                    <button className="dropdown-toggle" type="button"><small>PRECIOS ({precios.length})</small></button>
                    <div className="dropdown-menu dropdown-menu-right">
                        {precios.map((precio, i) => {
                            return (
                            <li key={precio.id || i} className="dropdown-item d-flex align-center">
                                <div className="text-left p-r-15">#{i + 1}</div> <input type="number" name={`compra[items_compra][p${index}][precios][${i}][total]`} value={precio.total} onChange={e => onChangePreciosVenta(precio.id, e.target.value)} className="form-control text-right" style={{minWidth: 150}} />
                                <button type="button" className="p-l-10"><i className="fas fa-trash" onClick={() => removePrecio(precio.id)}></i></button>
                                <input type="hidden" name={`compra[items_compra][p${index}][precios][${i}][id]`} value={precio.id} />
                                <input type="hidden" name={`compra[items_compra][p${index}][precios][${i}][precio_venta]`} value={precio.precio_venta} />
                                <input type="hidden" name={`compra[items_compra][p${index}][precios][${i}][porciento_beneficio]`} value={precio.porciento_beneficio} />
                            </li>
                        )})}
                        <li className="dropdown-divider"></li>
                        <li className="dropdown-item text-right"><button type="button" onClick={addPrecio}>Agregar +</button></li>
                    </div>
                </div>
            </td>
            <td>
                <button
                    type='button'
                    className='btn'
                    onClick={() => removeItem(item.id)}>
                    <i className='fas fa-trash'></i>
                </button>
            </td>
        </tr>;
};

export default ProductoCompra;